import React, { useState } from "react";
import { ReCaptchaProvider } from "@wss/re-captcha";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import AddToCartSuccess from "~/ProductDetails/Pricing/AddToCart/AddToCartSuccess";
import { OutletAttributes } from "~/ProductDetails/ProductDetailPageResult";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import PlusShipping from "~/ProductDetails/Pricing/PlusShippingLevels";
import OutletAddToCart from "./OutletAddToCart";
import P from "~/ProductDetails/Pricing/MapPrice/P";
import { User } from "~/common/Store/models/User";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import CreditKeyBanner from "~/ProductDetails/CreditKey/CreditKeyBanner";
import Ribbons from "~/ProductDetails/Pricing/Ribbons";
import("~/less/specials.less");
interface Props {
  product: PricingProduct;
  outletAttributes: OutletAttributes;
  itemInCart: boolean;
  onAddToCart: () => void;
  user: User;
  mounted: boolean;
}
const OutletPricingBox = ({
  product,
  outletAttributes,
  itemInCart,
  onAddToCart,
  user
}: Props) => {
  const {
    newProductLink,
    originalPrice,
    originalProductAvailable,
    outletProductId,
    callForPricing
  } = outletAttributes;
  const outletPrice = product.price.price;
  const [itemAdded, setItemAdded] = useState(false);
  const handleAddToCart = () => {
    setItemAdded(true);
    onAddToCart?.();
  };
  const freeShippingRibbonConditional = product?.hasFreeShipping && !user.hasWebPlus && !product?.isRequestAQuoteEnabled;
  return <div id="subject" className="side-col ag-product" data-sentry-component="OutletPricingBox" data-sentry-source-file="OutletPricingBox.tsx">
      <div className="ag-item box" id="priceBox">
        {callForPricing && freeShippingRibbonConditional ? <Ribbons product={product} user={user} /> : null}
        <div className="pricing">
          {callForPricing && <ReCaptchaProvider>
              <P {...product} price={{
            ...product.price,
            hideWhyDoWeDoThis: false
          }} user={user} isGoogleView={false} showBelowMinimumAdvertisedPriceForLoggedInCustomers={false} />
            </ReCaptchaProvider> || <>
              {freeShippingRibbonConditional ? <Ribbons product={product} user={user} /> : null}
              <p className="price" data-testid="price">
                {formatAsCurrency.formatIfUndefined(outletPrice)}
                <span className="each">/EA</span>
              </p>
              <CreditKeyBanner price={outletPrice} />
              <PlusShipping hasFreeShipping={product.hasFreeShipping} hasWebPlusDiscountedShipping={product.hasWebPlusDiscountedShipping} isWebstaurantPlusEligible={product.isWebstaurantPlusEligible} />
              {originalProductAvailable && <div className="mb-2 py-1 px-2 rounded-sm bg-gray-100">
                  <a className="block text-gray-800 font-semibold hover:text-red-700 text-xs" style={{
              textShadow: "none"
            }} href={newProductLink}>
                    Purchase This Item New for{" "}
                    <span data-testid="original-price" className="text-sm text-red-700 font-bold">
                      {formatAsCurrency.formatIfUndefined(originalPrice)}
                    </span>{" "}
                    <i className="icon-breadcrumb" />
                  </a>
                </div>}
            </>}
          <OutletAddToCart product={product} outletId={outletProductId} itemInCart={itemInCart} onAddToCart={handleAddToCart} data-sentry-element="OutletAddToCart" data-sentry-source-file="OutletPricingBox.tsx" />
        </div>
      </div>
      {itemAdded && <AddToCartSuccess quantity={1} />}
    </div>;
};
export default connectUserAndChat(OutletPricingBox);